import React, { useContext } from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ProjectContext } from "../../ProjectContext";

function ProgressBar() {
  const { dbuser, dbuserx1, dbReward, } = useContext(ProjectContext)
  const normalizedValue = dbuserx1 === 0 ? 0 : (dbReward / dbuserx1) * 100;
  return (
    <div
      style={{
        width: "220px",
        height: "220px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#000",
        borderRadius: "50%",
        padding: "20px",
        boxShadow: "0px 0px 25px rgba(0, 255, 255, 0.5)", // Neon Glow Effect
      }}
    >
      {/* Inner Background Glow */}
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: "radial-gradient(circle, #222 40%, #000 90%)",
          boxShadow: `
            inset 8px 8px 15px rgba(255, 255, 255, 0.1), 
            inset -8px -8px 20px rgba(0, 0, 0, 0.9),
            0px 0px 10px rgba(0, 255, 255, 0.3)
          `,
        }}
      ></div>

      {/* Circular Progress Bar */}
      <CircularProgressbarWithChildren
        value={normalizedValue} // Current progress as percentage of max value
        text={dbuser?.address !== '0x0000000000000000000000000000000000000000' && dbuser !== null ? `${normalizedValue.toFixed(2)}%` : "-"}
        strokeWidth={10}
        styles={buildStyles({
          strokeLinecap: "round",
          rotation: 0.75,
          pathColor: "url(#gradient)",
          trailColor: "#111",
          textColor: "#0ff",
        })}
      >
        {/* Glass Effect */}
        <div
          style={{
            position: "absolute",
            top: "15%",
            left: "25%",
            width: "50%",
            height: "25%",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.2)",
            filter: "blur(10px)",
          }}
        ></div>

        {/* Neon Gradient */}
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0ff" />
              <stop offset="50%" stopColor="#00bcd4" />
              <stop offset="100%" stopColor="#0077b6" />
            </linearGradient>
          </defs>
        </svg>
      </CircularProgressbarWithChildren>
    </div>
  );
}

export default ProgressBar;
